/**
 * The one place that decides whether the console talks to a server or to the
 * stubs. Deleting src/stubs and this file's `import` is the whole switch.
 *
 *   VITE_API=http  → the real backend at /api
 *   anything else  → stubs (default while the backend does not serve this shape)
 *
 * There is one factory per entry point and no factory that makes both. Which
 * one runs is decided once, in src/entry, from the host.
 */

import { HttpAccountApi, HttpClusterApi } from './http';
import { createStubAccountApi } from '../stubs/stubAccountApi';
import { createStubClusterApi } from '../stubs/stubClusterApi';
import type { AccountApi, ClusterApi } from './client';

export const USING_STUBS = import.meta.env.VITE_API !== 'http';

export function createAccountApi(): AccountApi {
  return USING_STUBS ? createStubAccountApi() : new HttpAccountApi();
}

export function createClusterApi(): ClusterApi {
  return USING_STUBS ? createStubClusterApi() : new HttpClusterApi();
}
